import * as React from 'react';
const PiediGonfiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M66.42 72.02s1.52 11.66 1.52 17.02-5.71 21.22-5.71 27.75 4.2 11.19 11.19 11.19c8.51 0 14.81-2.8 19.59-2.8 8.05 0 13.06 2.8 20.99 2.8 5.71 0 8.4-1.4 9.79-1.4s3.73 1.4 7 1.4c2.93 0 7-1.34 7-6.32 0-.52-.2-1.04-.53-1.45s-.8-.72-1.33-.72c-10.74 0-19.65-8.82-24.73-11.09-8.33-3.73-18.19-8.33-18.19-13.99V72.02"
      className="prefix__cls-2"
    />
    <path
      d="M74.81 98.6c-1.38 3.08-.05 6.59 2.8 8.4"
      className="prefix__cls-2"
    />
    <path
      d="m110.89 92.36 1.39-8.25M118.96 96.22l4.6-8.1M126.45 101.15l6.34-5.4"
      className="prefix__cls-1"
    />
  </svg>
);
export default PiediGonfiIcon;
